<template>
  <div class="d-flex flex-column">
    <div class="d-lg-none chat-mobile-navigation px-0" @click="changeMobileState(mobileChatStates.LIST)">
      <i class="la la-angle-left la-lg"></i>
      Chats
    </div>
    <header v-if="activeChat" class="chat-dialog-header chat-section">
      <div>
        <h5 class="fw-normal mb-0">{{ activeChat.nama_pemrakarsa }}</h5>
      </div>
    </header>
    <div class="chat-dialog-body" ref="chatDialogBody">
      <div>
        <div class="dialog-divider"></div>
        <div class="dialog-messages">
          <ChatMessage
            v-for="chat of dataChat"
            :key="chat.id"
            :message="chat"
            :owner="chat.id_penerima === '1'"
          ></ChatMessage>
        </div>
      </div>
    </div>
    <div class="chat-section new-message mb-0 mx-0">
      <b-input v-model="newMessage" placeholder="Ketik Pesan"></b-input>
      <b-button
        variant="danger"
        class="px-4 new-message-btn text-white ms-3"
        type="button"
        :disabled="!newMessage || isLoadingSend"
        @click="sendChat"
      >
        <Loader v-if="isLoadingSend" />
        <PaperPlane v-else />
      </b-button>
    </div>
  </div>
</template>

<script>
import { chatList, chatRoom } from '../../chatData'
import { ChatMixin } from '@/mixins/chat'
import ChatMessage from './ChatMessage'
import Loader from '../../../../components/Loader/Loader'
import PaperPlane from '../../../../components/Icons/PaperPlane.vue'
import axios from 'axios'

export default {
  components: { ChatMessage, Loader, PaperPlane },
  mixins: [ChatMixin],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      userData: JSON.parse(localStorage.getItem('userPengendalian') || {}),
      newMessage: '',
      isLoadingSend: false,
      activeChat: null,
      dataChat: [],
    }
  },
  methods: {
    async getChatRoom() {
      const id_chat_room = this.$route.query.id_chat_room
      const res = await axios.get(`${this.baseapiPengendalian}api/chat_room/${id_chat_room}`, this.getApiOption())
      // this.activeChat = chatRoom.find((d) => d.id == id_chat_room)
      this.activeChat = res.data?.data || null
    },
    async getChatList() {
      const id_chat_room = this.$route.query.id_chat_room
      const res = await axios.get(
        `${this.baseapiPengendalian}api/chat?sort=createdAt,ASC&limit=0&filter=id_chat_room,=,${id_chat_room}`,
        this.getApiOption(),
      )
      // this.dataChat = chatList.filter((d) => d.id_chat_room == id_chat_room)
      this.dataChat = res.data?.data || []
    },
    async sendChat() {
      try {
        this.isLoadingSend = true
        await axios.post(
          `${this.baseapiPengendalian}api/chat`,
          {
            id_chat_room: this.activeChat.id,
            id_penerima: this.activeChat.id_pemrakarsa,
            isi_chat: this.newMessage,
          },
          this.getApiOption(),
        )
        this.newMessage = ''
        this.getChatList()
      } catch (error) {
        Swal.fire({
          title: 'Gagal',
          text: 'Terjadi kesalahan saat mengirim pesan',
          icon: 'error',
        })
      } finally {
        this.isLoadingSend = false
      }
    },
    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.userData.accessToken,
        },
        ...option,
      }
    },
  },
  watch: {
    async $route(to, from) {
      if (!to.query.id_chat_room) return
      if (to.query.id_chat_room !== from.query.id_chat_room) {
        await this.getChatRoom()
        await this.getChatList()
      }
    },
  },
  async mounted() {
    if (this.$route.query.id_chat_room) {
      await this.getChatRoom()
      await this.getChatList()
    }
  },
}
</script>

<style src="./ChatDialog.scss" lang="scss" scoped></style>
<style scoped>
:deep(.data-loader i) {
  margin: 0px !important;
}
</style>
